module.exports = __webpack_public_path__ + "img/3轴台虎钳设计模型.SLDASM.2e97c8e0.jpg";